import React, {
  useEffect,
  useState
} from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
// Local
import { API_URL } from '../../../constant'
import { api } from '../../../action/api'
import Nlp from '../../common/nlp'
import {
  filterPayloads,
  NLPPayload
} from '../../../json/nlpPayload'
import {
  EncounterConditionDisplay,
  User
} from '../../authenticated/types'

type EncounterDetail = {
  conditions: EncounterConditionDisplay[]
}

type NlpConditionEvidenceOwnProps = {
  match: {
    params: {
      encounterConditionId: string
      encounterId: string
    }
  }
}

type NlpConditionEvidenceReduxProps = {
  currentUser: User
}

type NlpConditionEvidenceProps = NlpConditionEvidenceOwnProps & NlpConditionEvidenceReduxProps

/**
 * From an ID of an encounter condition, presumably a condition that was generated by NLP,
 * we want to show the document that was the raw evidence for that condition.
 */
function NlpConditionEvidence(
  props: NlpConditionEvidenceProps
): JSX.Element {
  const {
    match,
    currentUser
  } = props

  const { encounterConditionId } = match.params
  const { encounterId } = match.params

  const [ nlpData, setNlpData ] = useState<NLPPayload[] | null>(null)
  const [ isDocumentNotFound, setIsDocumentNotFound ] = useState<boolean>(false)

  const setError = () => {
    setIsDocumentNotFound(true)
  }

  const getNLPText = (
    nlpDocumentId: string,
    conditionDisplay: EncounterConditionDisplay
  ) => {
    api.get(API_URL.NLP_TEXT(nlpDocumentId))
      .then(({ data }: { data: NLPPayload[] }) => {
        const reducedPayloads = filterPayloads(
          data,
          conditionDisplay
        )
        const finalPayloads = reducedPayloads.length > 0
          ? reducedPayloads
          : data
        setNlpData(finalPayloads)
      })
      .catch(() => setError())
  }

  const processEncounterDetail = (
    encounterDetail: EncounterDetail,
    conditionId: string
  ) => {
    const conditionDisplay = encounterDetail.conditions.find(
      cond => cond.id === conditionId
    )
    if (!conditionDisplay) {
      setError()
      return
    }

    const nlpDocumentId = (conditionDisplay.rules && conditionDisplay.rules[0].targetId) || ''
    if (nlpDocumentId === '') {
      setError()
      return
    }
    getNLPText(
      nlpDocumentId,
      conditionDisplay
    )
  }

  const fetchEncounter = () => {
    const userRole = currentUser.type
    const urlEncounter = `${API_URL.GET_ENCOUNTER_DETAIL_BY_ID_WITH_ROLE(userRole)}${encounterId}`
    api.get(urlEncounter)
      .then(({ data }: { data: EncounterDetail }) => {
        processEncounterDetail(
          data,
          encounterConditionId
        )
      })
      .catch(() => {
        setError()
      })
  }

  useEffect(() => {
    fetchEncounter()
  }, [])

  if (isDocumentNotFound) {
    return (
      <>Document not found</>
    )
  }

  if (!nlpData) {
    return (
      <>Please wait</>
    )
  }

  return (
    <>
      <div className="nlp-modal-header">
        <span className="nlp-header-doc">Document Type:</span>
        { ' ' }
        { nlpData.length > 0 && nlpData[0].documentTypeCode }
        <br />
        <span className="nlp-header-doc">
          Document Date of Service:{ ' ' }
        </span>
        { ' ' }
        { nlpData.length > 0 && nlpData[0].documentDateOfService }
      </div>
      { React.createElement(Nlp as any, { payload: nlpData }) }
    </>
  )
}

type RootState = {
  user: User
}

const ConnectedNlpConditionEvidence = withRouter(
  connect(
    (state: RootState) => ({
      currentUser: state.user
    }),
    {}
  )(NlpConditionEvidence as any) as any
)

export default ConnectedNlpConditionEvidence as React.ComponentType<Record<string, never>>
